module.exports = __webpack_public_path__ + "img/safe_icon.60064b8c.png";